const deepBlue = {
    /**
     * Lighter shades (50 - 400)
     */
    50: '#e2e5e7',   // Much lighter shade
    100: '#c5cad0',  // Very light shade
    200: '#a7afb9',  // Lighter shade
    300: '#8a94a2',  // Light shade
    400: '#6d798b',  // Slightly light shade

    /**
     * Base color (500)
     */
    500: '#071c28',  // Base color

    /**
     * Darker shades (600 - 900)
     */
    600: '#061925',  // Slightly darker shade
    700: '#051621',  // Darker shade
    800: '#04131d',  // Dark shade
    900: '#030f19',  // Very dark shade

    /**
     * Accent shades (A100 - A700)
     */
    A100: '#2c3e50', // Light accent
    A200: '#243746', // Normal accent
    A400: '#1b2e3b', // Dark accent
    A700: '#132530', // Very dark accent
};

export default deepBlue;
